import React from "react";
import ReactDOM from "react-dom/client";
import { ReactFlowProvider } from "reactflow";

import GraphProvider from "./contexts/GraphProvider";
import AutoLayoutProvider from "./contexts/AutoLayoutProvider";
import FlowElementsProvider from "./contexts/FlowElementsProvider";

import App from "./App";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ReactFlowProvider>
      <AutoLayoutProvider>
        <FlowElementsProvider>
          <GraphProvider>
            <App />
          </GraphProvider>
        </FlowElementsProvider>
      </AutoLayoutProvider>
    </ReactFlowProvider>
  </React.StrictMode>
);
